"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySelectorTarget = exports.GroupChatMessageType = exports.CommunicationTemplateStatus = exports.CommunicationTemplateTarget = exports.CommunicationTemplatePlatform = exports.CommunicationSubscriptionGroupName = void 0;
var CommunicationSubscriptionGroupName;
(function (CommunicationSubscriptionGroupName) {
    CommunicationSubscriptionGroupName["Marketing"] = "Marketing";
    CommunicationSubscriptionGroupName["GroupUpdates"] = "Group updates";
    CommunicationSubscriptionGroupName["Reminders"] = "Reminders";
    CommunicationSubscriptionGroupName["Communications"] = "Communications";
    CommunicationSubscriptionGroupName["GroupCommunication"] = "Groups Communication";
    CommunicationSubscriptionGroupName["System"] = "System";
})(CommunicationSubscriptionGroupName = exports.CommunicationSubscriptionGroupName || (exports.CommunicationSubscriptionGroupName = {}));
var CommunicationTemplatePlatform;
(function (CommunicationTemplatePlatform) {
    CommunicationTemplatePlatform["Sms"] = "sms";
    CommunicationTemplatePlatform["Email"] = "email";
    CommunicationTemplatePlatform["PushNotification"] = "push_notification";
    CommunicationTemplatePlatform["GroupChat"] = "group_chat";
})(CommunicationTemplatePlatform = exports.CommunicationTemplatePlatform || (exports.CommunicationTemplatePlatform = {}));
var CommunicationTemplateTarget;
(function (CommunicationTemplateTarget) {
    CommunicationTemplateTarget["Accounts"] = "accounts";
    CommunicationTemplateTarget["Groups"] = "groups";
})(CommunicationTemplateTarget = exports.CommunicationTemplateTarget || (exports.CommunicationTemplateTarget = {}));
var CommunicationTemplateStatus;
(function (CommunicationTemplateStatus) {
    CommunicationTemplateStatus["Active"] = "active";
    CommunicationTemplateStatus["Inactive"] = "inactive";
})(CommunicationTemplateStatus = exports.CommunicationTemplateStatus || (exports.CommunicationTemplateStatus = {}));
var GroupChatMessageType;
(function (GroupChatMessageType) {
    GroupChatMessageType["Moment"] = "moment";
    GroupChatMessageType["Exercise"] = "exercise";
})(GroupChatMessageType = exports.GroupChatMessageType || (exports.GroupChatMessageType = {}));
var QuerySelectorTarget;
(function (QuerySelectorTarget) {
    QuerySelectorTarget["Accounts"] = "accounts";
    QuerySelectorTarget["Groups"] = "groups";
})(QuerySelectorTarget = exports.QuerySelectorTarget || (exports.QuerySelectorTarget = {}));
//# sourceMappingURL=communications.js.map